// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3Maie","title":"ClientInsurance_title__3Q_mv","itemText":"ClientInsurance_itemText__uJIyo"};